import React from "react";
import Like from "../../Assets/like.png";
import Achievement from "../../Assets/achievement.png";
import Profressional from "../../Assets/professional.png";

interface Props {
  type: 0 | 1 | 2;
  amount: string;
  text: string;
}

const Item = (props: Props) => {
  return (
    <div className="item">
      <div className="top">
        <img src={props.type === 0 ? Like : props.type === 1 ? Achievement : Profressional} alt="" />
        <div>{props.amount}</div>
      </div>
      <div className="text">{props.text}</div>
    </div>
  );
};

export default Item;
